import React from 'react';
import { Card, Col, Row, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Greetings = () => {

    return (
        <Card className="mb-1 p-2">
            <Row className="g-2 align-items-center d-flex">
                <Col xs="auto">
                    <img src="/img/ordenes96.png" alt="connectCircle" height={30} />
                </Col>
                <Col>
                    <h5 className="mb-0 ">Cat&aacute;logo de productos</h5>
                </Col>
                <Col sm="auto" className="ms-auto">
                    <Link to="/productos/Nuevo">
                        <Button size="sm" variant="falcon-primary">
                            Nuevo Producto
                        </Button>
                    </Link> 
                </Col>
            </Row>
        </Card>
    );
};


export default Greetings;
